export const getLocalStorage = (key) => {
  return JSON.parse(window.localStorage.getItem(key));
};

export const getLocalStorageConfig = (key) => {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
};

export const setLocalStorage = (key, data) => {
  return window.localStorage.setItem(key, JSON.stringify(data));
};

export const removeLocalStorage = (key) => {
  window.localStorage.removeItem(key);
};

export const removeLocalStorageMultiple = (keys) => {
  keys.forEach((key) => {
    window.localStorage.removeItem(key);
  });
};

export const clearLocalStorage = (key) => {
  window.localStorage.clear();
};

export const getSessionStorage = (key) => {
  const item = window?.sessionStorage?.getItem(key);
  if (item === null || item === "undefined" || item === "") {
    return null;
  }
  return JSON.parse(item);
};

export const setSessionStorage = (key, data) => {
  return window.sessionStorage.setItem(key, JSON.stringify(data));
};

export const removeSessionStorage = (key) => {
  window.sessionStorage.removeItem(key);
};

export const clearSessionStorage = (key) => {
  window.sessionStorage.clear();
};

const DINE_IN_KEY = "dine-in";
const DINE_IN_BACKUP_KEY = "dineInSessionBackup";

export const getDineInSession = () => {
  const sessionData = getSessionStorage(DINE_IN_KEY);
  if (sessionData?.storeId) {
    return sessionData;
  }
  const backupData = getLocalStorage(DINE_IN_BACKUP_KEY);
  if (!backupData) {
    return sessionData;
  }
  const healed = { ...backupData, ...(sessionData || {}) };
  setSessionStorage(DINE_IN_KEY, healed);
  return healed;
};

export const syncDineInSession = (data) => {
  setSessionStorage(DINE_IN_KEY, data);
  setLocalStorage(DINE_IN_BACKUP_KEY, data);
  return data;
};

export const patchDineInSession = (patch) => {
  const merged = { ...(getDineInSession() || {}), ...patch };
  return syncDineInSession(merged);
};

export const clearDineInSession = () => {
  removeSessionStorage(DINE_IN_KEY);
  window.localStorage.removeItem(DINE_IN_BACKUP_KEY);
};
